import React, { useState } from 'react';
import Apiconnect from "../services/Apiconnect.js";
import { ToastContainer, toast } from 'react-toastify';
import {  Spinner } from 'react-bootstrap';

const Changepassword = () => {
 
    const [passwordData, setPasswordData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
 
    const [isLoading, setIsLoading] = useState(false);
 
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({
            ...passwordData,
            [name]: value
        });
    };
 
 
    const handleSubmit = async (e) => {
        e.preventDefault();
 
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            toast.error('New passwords do not match');
            return;
        }

        if (passwordData.newPassword.length < 8) {
            toast.error('New password must be at least 8 characters long');
            return;
        }

        setIsLoading(true);

        try {
            const token = localStorage.getItem('token');
            const payload = {
                old_password: passwordData.oldPassword,
                new_password: passwordData.newPassword
            };
 
            const response = await Apiconnect.postData("auth/changepass", payload, token);
            console.log(response.data);

            if (response.data && response.data.status === 1) {
                // Password changed successfully
                toast.success('Password changed successfully');
 
                setPasswordData({
                    oldPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                });
            } else {
                const errorMessage = response.data?.message || 'Failed to change password';
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error("Error changing password:", error);
            const errorMessage = error.response.data.message || 'Failed to change password';
            toast.error(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row mt-2 mb-2">
                    <div className="col-md-3 box-margin height-card">
                    </div>
                    <div className="col-md-6 box-margin height-card">
                        <div className="card shadow">
                            <div className="card-body">
                                <h4 className="mb-4">Change Password</h4>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-3">
                                        <label className="col-form-label">Current Password <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="oldPassword"
                                            value={passwordData.oldPassword}
                                            onChange={handleInputChange}
                                            required
                                            minLength="8"
                                        />
                                    </div>

                                    <div className="form-group mb-4">
                                        <label className="col-form-label">New Password <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="newPassword"
                                            value={passwordData.newPassword}
                                            onChange={handleInputChange}
                                            required
                                            minLength="8"
                                        />
                                        <small className="text-muted">Password must be at least 8 characters long</small>
                                    </div>

                                    <div className="form-group mb-4">
                                        <label className="col-form-label">Confirm New Password <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="confirmPassword"
                                            value={passwordData.confirmPassword}
                                            onChange={handleInputChange}
                                            required
                                            minLength="8"
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary d-flex justify-content-center"
                                        style={{ backgroundColor: '#072848', color: 'white' }}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="me-2"
                                                />
                                                Changing Password...
                                            </>
                                        ) : (
                                            'Change Password'
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           <ToastContainer/>
        </>
    );
};

export default Changepassword;